<template>
  <div>
    <div
      v-if="buttonPosition === 'top'"
      class="form-builder__option form-builder__option_horizontal"
    >
      <div class="text-center q-pa-md">
        <AppButtonLink
          :label="$t('label.addAutoresponders')"
          :disable="!canAddIntegration"
          icon-right="fl:add_round"
          @click="addIntegration"
        />
      </div>
    </div>
    <q-form
      v-for="(item, index) in autoresponders"
      ref="form"
      :key="item.id"
      class="form-builder__option form-builder__option_horizontal"
      greedy
    >
      <AutoresponderItem
        v-model="autoresponders[index]"
        @remove="removeIntegration(index)"
        @input="onInput"
      >
        <component
          :is="item.data.type"
          v-if="item.data"
          v-model="autoresponders[index]"
          @input="onInput"
        />
      </AutoresponderItem>
    </q-form>
    <div
      v-if="buttonPosition === 'bottom'"
      class="form-builder__option form-builder__option_horizontal"
    >
      <div class="text-center q-pa-md">
        <AppButtonLink
          :label="$t('label.addAutoresponders')"
          :disable="!canAddIntegration"
          icon-right="fl:add_round"
          @click="addIntegration"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppButtonLink from 'common/components/buttons/AppButtonLink';
import { MAX_AUTORESPONDERS } from 'common/helpers/data/autoresponders';
import handleError from 'common/helpers/handleError';
import randomString from 'common/helpers/randomString';
import { mapActions } from 'vuex';
import AutoresponderItem from './AutoresponderItem';
import ActiveCampaign from './integrations/ActiveCampaign';
import GetResponse from './integrations/GetResponse';
import GoogleSpreadSheets from './integrations/GoogleSpreadSheets';
import KlickTipp from './integrations/KlickTipp';
import MailChimp from './integrations/MailChimp';
import Quentn from './integrations/Quentn';

export default {
  name: 'AutoresponderList',
  components: {
    AppButtonLink,
    AutoresponderItem,
    quentn: Quentn,
    mailchimp: MailChimp,
    klicktipp: KlickTipp,
    getresponse: GetResponse,
    activecampaign: ActiveCampaign,
    googlespreadsheets: GoogleSpreadSheets,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    buttonPosition: {
      type: String,
      default: 'bottom',
      validate: (value) => ['top', 'bottom'].includes(value),
    },
  },
  data() {
    return {
      autoresponders: [],
    };
  },
  computed: {
    canAddIntegration() {
      return this.autoresponders.length < MAX_AUTORESPONDERS;
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        this.autoresponders = this.value;
      },
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    ...mapActions('dashboard', ['fetchAutoresponders']),
    async fetch() {
      try {
        this.$q.loading.show();
        await this.fetchAutoresponders();
      } catch (error) {
        handleError(error);
      } finally {
        this.$q.loading.hide();
      }
    },
    addIntegration() {
      if (!this.canAddIntegration) {
        return;
      }
      this.autoresponders.push({
        id: randomString(),
      });
    },
    removeIntegration(index) {
      this.autoresponders.splice(index, 1);
      this.onInput();
    },
    async onInput() {
      await this.$nextTick();
      const formValidationState = await Promise.all(this.$refs.form.map((value) => value.validate()));
      const autoresponders = this.autoresponders
        .filter((value, index) => formValidationState[index])
        .map(({ id, ...item }) => item);
      this.$emit('update', autoresponders);
      this.$refs.form.map((value) => value.resetValidation());
    },
  },
};
</script>

<style scoped>

</style>
